import axios from 'axios'
import qs from 'qs'
import _ from 'lodash'

export function checkEmail () {
  let errors = _.clone(this.errors)
  delete errors.guardianEmail
  // vue doesn't watch the values of the object, so replace the object to update it
  this.errors = errors
  this.fields.guardianFirstName = ''
  this.fields.guardianSurname = ''
  this.fields.guardianMobileNumber = ''
  this.fields.guardianAlternativeNumber = ''
  this.fields.guardianResidentialAddress = ''
  if (!this.fields.guardianEmail.trim().length) {
    this.guardianAccountStatus = 'unknown'
    return
  }
  const url = '/implanter/dashboard/checkEmail?email=' + this.fields.guardianEmail
  axios({
    method: 'POST',
    url,
    data: qs.stringify({
      email: this.fields.guardianEmail
    }),
    maxRedirects: 0
  }).then((response) => {
    if (response?.data?.status === 'success') {
      if (response?.data?.exists) {
        if (response?.data?.organisational) {
          this.guardianAccountStatus = 'unknown'
          errors = _.clone(this.errors)
          errors.guardianEmail = {
            code: 'guardian-email-taken',
            type: 'validation',
            value: 'An organisational account already exists with this email address. Companion animals can only be assigned to personal accounts. Please use a different email address.'
          }
          this.errors = errors
        } else {
          this.guardianAccountStatus = 'exists'
          this.fields.guardianFirstName = response?.data?.firstName
          this.fields.guardianSurname = response?.data?.surname
          this.fields.guardianMobileNumber = response?.data?.mobileNumber
          this.fields.guardianAlternativeNumber = response?.data?.alternativeNumber
          this.fields.guardianResidentialAddress = response?.data?.address
        }
      } else {
        if (response?.data?.valid) {
          // Only show this if they've added a valid email address
          this.guardianAccountStatus = 'new'
        } else {
          this.guardianAccountStatus = 'unknown'
          errors = _.clone(this.errors)
          errors.guardianEmail = {
            code: 'guardian-email-invalid',
            type: 'validation',
            value: 'Invalid email address'
          }
          this.errors = errors
        }
      }
    } else {
      this.guardianAccountStatus = 'unknown'
      errors = _.clone(this.errors)
      errors.guardianEmail = {
        code: 'guardian-email-check-failed',
        type: 'error',
        value: 'We were unable to validate this email, please copy any information and refresh, or try again later'
      }
      this.errors = errors
    }
  }).catch(() => {
    this.guardianAccountStatus = 'unknown'
    errors = _.clone(this.errors)
    errors.guardianEmail = {
      code: 'guardian-email-check-failed',
      type: 'error',
      value: 'We were unable to validate this email, please copy any information and refresh, or try again later'
    }
    this.errors = errors
  })
}
